function logoutUser(){
    localStorage.removeItem('Token');
    location.reload();
}

export default logoutUser ;